"use strict";
const da = {
    "startButton.label": "Få svar hurtigt",
    "backButton.label": "Tilbage",
    "closeButton.label": "Luk",
    "initialPopover.title": "Leder du efter et hurtigt svar?",
    "initialPopover.subtitle": "Klik her, stil et spørgsmål og få et svar.",
    "support.title": "Kontakt vores kundeservice",
    "support.subtitle": "Kontakt vores kundeservice via en af mulighederne nedenfor",
    "support.email.title": "Send os en email",
    "support.email.subtitle": "Send os en email og vi vil vende tilbage hurtigst muligt",
    "support.iframe.title": "Send os en besked",
    "support.iframe.subtitle": "Send os en besked og vi vil vende tilbage hurtigst muligt",
    "support.phone.title": "Telefon",
    "support.phone.subtitle": "Se vores telefonnummer og åbningstid er for kundeservice",
    "support.chat.title": "Chat",
    "support.chat.subtitle": "med vores kundeservice",
    "support.askAnother": "Stil et nyt spørgsmål",
    "support.error.title": "Noget gik galt",
    "support.error.description": "Tjek din internetforbindelse og prøv igen",
    "form.title": "Stil et spørgsmål",
    "form.titleNew": "Stil et nyt spørgsmål",
    "form.placeholder": "Skriv dit spørgsmål her",
    "form.buttonLabel": "Søgning",
    "form.clearInput": "Ryd søgning",
    "form.validationError": "Du skal stille et spørgsmål",
    "answer.supportLabel": "Kontakt vores kundeservice her",
    "answer.showMore": "Læs mere",
    "answer.additionalContent.moreInfo": "Mere info",
    "answer.error.title": "Noget gik galt...",
    "answer.error.description": "Tjek din internetforbindelse og prøv igen",
    "answers.a11y.summary": "Svar [](index) af [](count)",
    "answers.a11y.tab": "Gå til svar [](index)",
    "answer.viewOriginal": "Se oprindeligt svar",
    "answer.copy.originalAnswerLink": "Kopier link til oprindeligt svar",
    "noAnswer.label": "Det ser ud til, at dit spørgsmål ikke er dækket af de emner, vi kan svare på. \n \nPrøv at spørge igen, eller kontakt kundeservice.",
    "feedback.positive.label": "Ja",
    "feedback.positive.ariaLabel": "Dette svar var nyttigt",
    "feedback.negative.label": "Nej",
    "feedback.negative.ariaLabel": "Dette svar var ikke nyttigt",
    "feedback.label": "Var dette svar nyttigt?",
    "feedback.label.reviewed": "Tak for din feedback",
    "success.title": "Tak for din feedback. Vi er glade for, at du kunne bruge svaret.",
    "success.button.title": "Tilbage til svar",
    "phone.title": "Ring til os",
    "phone.subtitle": "Du er velkommen til at ringe på",
    "phone.openingHoursTitle": "Vores åbningstider er:",
    "phone.askAnother": "Stil et nyt spørgsmål",
    "phone.available": "Tilgængelig",
    "phone.unavailable": "Ikke tilgængelig",
    "email.title": "Kontakt os via e-mail",
    "email.subtitle": "Vi sender dit spørgsmål videre til en fra vores team, som vil kontakte dig hurtigst muligt.",
    "email.userEmailPlaceholder": "Skriv din e-mail her",
    "email.messagePlaceholder": "Skriv beskeden her",
    "email.error.title": "Kunne ikke sende beskeden",
    "email.error.subtitle": "Prøv igen, og hvis problemet fortsat forekommer, benyt en af de andre kontaktmuligheder.",
    "email.send": "Send",
    "email.sending": "Sender...",
    "email.sendCopyToSelf": "Send kopi til mig selv",
    "email.messageTemplate": "Hej kundeservice\n \nJeg har et spørgsmål: [](question)",
    "email.messageTemplatePostProcess": "Fra: [](userEmail)\n \n[](message)",
    "emailSuccess.title": "Vi har modtaget din e-mail",
    "emailSuccess.subtitle": "En fra vores team kontakter dig på den e-mailadresse, du har angivet.",
    "emailSuccess.finish": "Afslut",
    "sidebar.close": "Luk",
    "sidebar.originalLink": "Se original",
    "topquestions.title": "Ofte stillede spørgsmål",
    "topquestions.placeholder.heading": "Stil et spørgsmål",
    "topquestions.placeholder.subheading": "Vi leverer et hurtigt svar",
    "globalError.description": "Noget gik galt.",
    "globalError.retryButtonLabel": "Prøv igen",
    expand: "Udvid",
    collapse: "Minimér",
    copied: "Kopieret",
    copy: "Kopier",
    open: "Åbn",
    references: "Referencer",
    "show.folder": "Vis mappe",
    "poweredBy.label": "Drevet af Raffle - Link til hjemmeside",
    "gpt.disclaimer": "Det samlede svar blev genereret af Raffles store sprogmodeller. Opsummeringen kan godt komme til at opsamle mere end det, der synes relevant, så tjek gerne søgeresultaterne nedenfor for at få ekstra information.",
    "chat.inputPlaceholder": "Skriv dit spørgsmål her",
    "chat.title": "Velkommen til Raffle Chat!",
    "chat.description": "Du kan spørge om alt, hvad der er relevant for dette websted - og du kan spørge i fri tekst ved hjælp af de ord, du finder passende!\n \nVi håber, du finder alle de svar, du har brug for.",
    "chat.askMePrompt": "Spørg mig om noget...",
    "chat.topicTooltip": "Nyt emne",
    "chat.regenerate": "Generer svar igen",
    "chat.stopStream": "Stop generering af svar",
    "chat.initialMessage": "Hej! ✋ Hvordan kan jeg hjælpe dig?",
    "chat.inappropriateQuestionResponse": "Vi har registreret nogle upassende elementer i dit spørgsmål, og kan derfor ikke give et svar. Prøv venligst at omformulere eller spørg om noget andet.",
    "chat.noSearchResultsResponse": "Vi kunne ikke finde nogle relevante søgeresultater til dit spørgsmål. Prøv at omformulere dit spørgsmål eller spørg om noget andet.",
    "chat.retryErrorMessage": "Noget gik galt. Prøv igen om lidt.",
    "chat.searching.title": "Søger...",
    "chat.searching.description": "Finder relevante resultater",
    "header.title.results": "Resultater",
    "header.title.answerPreview": "Forhåndsvisning af svar",
    "header.title.chat": "Chat",
    "header.title.support": "Support",
    "header.title.phoneSupport": "Telefonsupport",
    "header.title.emailSupport": "E-mail Support",
    "navigation.search": "Søg",
    "cta.startConversation": "Start en samtale",
    "search.noRelevantResults.title": "Vi fandt ingen relevante svar.",
    "search.noRelevantResults.description": "Her er hvad vi fandt i stedet for.",
    "summary.title": "Opsummering",
    "summary.disclaimer": "Information om Summary",
    "searchpopup.gdpr": "Information om GDPR",
    "searchpopup.message": "Information",
    toolbar: " Valgmuligheder",
    "reference.open": "Åbn reference",
    "feedback.title": "Din feedback er vigtig!",
    "feedback.subtitle": "Fik vi besvaret dit spørgsmål?",
    "feedback.commentTitle": "Tak for din feedback!",
    "feedback.commentSubtitle": "Vi sætter stor pris på din mening.",
    "feedback.minimizedTitle": "Hej! Vi ville sætte stor pris på, hvis du ville bruge et par sekunder på at vurdere vores selvbetjening.",
    "feedback.dismiss.text": "Spring over",
    "feedback.commentButton.ariaLabel": "Send kommentar",
    "feedback.comment.ariaLabel": "Kommentarfelt",
    "feedback.comment.label": "Har du en kommentar?",
    "chat.activeNow": "Aktiv nu",
};
const en = {
    "startButton.label": "Get a quick answer",
    "backButton.label": "Back",
    "closeButton.label": "Close",
    "initialPopover.title": "Are you looking for a quick answer?",
    "initialPopover.subtitle": "Click here, type in your question and get an answer",
    "support.title": "Contact our Customer Service",
    "support.subtitle": "Contact our Customer Service via one of the options below",
    "support.email.title": "Send us an email",
    "support.email.subtitle": "Send us an email and we will get back to you as soon and possible",
    "support.iframe.title": "Send us a message",
    "support.iframe.subtitle": "Send us a message and we will get back to you as soon as possible",
    "support.phone.title": "Phone",
    "support.phone.subtitle": "See our phone number and opening hours",
    "support.chat.title": "Chat",
    "support.chat.subtitle": "with out customer support",
    "support.askAnother": "Ask a new question",
    "support.error.title": "Something went wrong...",
    "support.error.description": "Check your network connection and try again",
    "form.title": "Ask a question",
    "form.titleNew": "Ask a new question",
    "form.placeholder": "Write your question here",
    "form.buttonLabel": "Search",
    "form.clearInput": "Clear search query",
    "form.validationError": "You have to type a question",
    "answer.supportLabel": "Contact our Customer Service here",
    "answer.showMore": "Read more",
    "answer.additionalContent.moreInfo": "More info",
    "answer.error.title": "Something went wrong...",
    "answer.error.description": "Check your network connection and try again",
    "answers.a11y.summary": "Answer [](index) of [](count)",
    "answers.a11y.tab": "Goto answer [](index)",
    "answer.viewOriginal": "View original answer",
    "answer.copy.originalAnswerLink": "Copy link to original answer",
    "noAnswer.label": "It looks like your question isn't covered by the subjects that we can answer. \n \nTry to ask again or contact Customer Service.",
    "feedback.positive.label": "Yes",
    "feedback.positive.ariaLabel": "This answer was helpful",
    "feedback.negative.label": "No",
    "feedback.negative.ariaLabel": "This answer was not helpful",
    "feedback.label": "Was this answer helpful?",
    "feedback.label.reviewed": "Thanks for your feedback",
    "success.title": "Thanks for your feedback, we're glad you could use the answer.",
    "success.button.title": "Back to answer",
    "phone.title": "Call us",
    "phone.subtitle": "You are welcome to call us at",
    "phone.openingHoursTitle": "Our opening hours are:",
    "phone.askAnother": "Ask a new question",
    "phone.available": "Available",
    "phone.unavailable": "Unavailable",
    "email.title": "Contact us via email",
    "email.subtitle": "We will pass on your question to one of our team members, who will contact you as soon as possible.",
    "email.userEmailPlaceholder": "Write your email here",
    "email.messagePlaceholder": "Write your message here",
    "email.error.title": "Unable to send the message",
    "email.error.subtitle": "Try again and if the issue persists use another of our support channels.",
    "email.send": "Send",
    "email.sending": "Sending… ",
    "email.sendCopyToSelf": "Send a copy to myself",
    "email.messageTemplate": "Hi Customer Service,\n \nI have a question: [](question)",
    "email.messageTemplatePostProcess": "From: [](userEmail)\n \n[](message)",
    "emailSuccess.title": "We have received your email",
    "emailSuccess.subtitle": "A member of our team will contact you on the email address you provided.",
    "emailSuccess.finish": "Finish",
    "sidebar.close": "Close",
    "sidebar.originalLink": "See original",
    "topquestions.title": "Frequently asked questions",
    "topquestions.placeholder.heading": "Enter a search query",
    "topquestions.placeholder.subheading": "We'll give you an immediate response",
    "globalError.description": "Something went wrong.",
    "globalError.retryButtonLabel": "Try again",
    expand: "Expand",
    collapse: "Collapse",
    copied: "Copied",
    copy: "Copy",
    open: "Open",
    references: "References",
    "show.folder": "Show folder",
    "poweredBy.label": "Powered by Raffle - link to website",
    "gpt.disclaimer": "The summary was generated by Raffles' large language models. As it may be flawed, please see original search results below for further detail.",
    "chat.inputPlaceholder": "Write your question here",
    "chat.title": "Welcome to Raffle Chat!",
    "chat.description": "You can ask about everything that is relevant to this website - and you can ask in free text using the words you see fit!\n \nWe hope you find all the answers you need.",
    "chat.askMePrompt": "Ask me anything...",
    "chat.topicTooltip": "New topic",
    "chat.regenerate": "Regenerate response",
    "chat.stopStream": "Stop generating response",
    "chat.initialMessage": "Hi there! ✋ How can I help you?",
    "chat.inappropriateQuestionResponse": "We've detected some inappropriate elements in your question, and can therefore not provide an answer. Please rephrase or ask something else.",
    "chat.noSearchResultsResponse": "We couldn’t find any relevant search results to your question. Try rephrasing your question or ask something else.",
    "chat.retryErrorMessage": "Something went wrong. Please try again in a few moments.",
    "chat.searching.title": "Searching...",
    "chat.searching.description": "Finding relevant results",
    "header.title.results": "Results",
    "header.title.answerPreview": "Answer Preview",
    "header.title.chat": "Chat",
    "header.title.support": "Support",
    "header.title.phoneSupport": "Phone Support",
    "header.title.emailSupport": "Email Support",
    "navigation.search": "Search",
    "cta.startConversation": "Start a conversation",
    "search.noRelevantResults.title": "We found no relevant answers.",
    "search.noRelevantResults.description": "Here’s what we found instead.",
    "summary.title": "AI Summary",
    "summary.disclaimer": "Summary disclaimer",
    "searchpopup.gdpr": "GDPR disclaimer",
    "searchpopup.message": "Search information",
    toolbar: "Toolbar options",
    "reference.open": "Open reference",
    "feedback.title": "Your feedback is important!",
    "feedback.subtitle": "Did we answer your question?",
    "feedback.commentTitle": "Thank you for your feedback!",
    "feedback.commentSubtitle": "We greatly appreciate your opinion.",
    "feedback.minimizedTitle": "Hello! We would greatly appreciate it if you would take a few seconds to rate our self-service.",
    "feedback.dismiss.text": "Skip",
    "feedback.commentButton.ariaLabel": "Send comment",
    "feedback.comment.ariaLabel": "Comment field",
    "feedback.comment.label": "Do you have a comment?",
    "chat.activeNow": "Active now",
};
const de = {
    "startButton.label": "Schnelle Antwort kriegen",
    "backButton.label": "Zurück",
    "closeButton.label": "Schließen",
    "initialPopover.title": "Suchen Sie eine schnelle Antwort?",
    "initialPopover.subtitle": "Bitte geben Sie hier Ihre Frage ein",
    "support.title": "Kontaktieren Sie unseren Kundenservice",
    "support.subtitle": "Wählen Sie eine der folgenden Möglichkeiten aus, um unseren Kundenservice zu kontaktieren",
    "support.email.title": "Schicken Sie uns eine E-Mail",
    "support.email.subtitle": "Schicken Sie uns eine E-Mail. Wir melden uns schnellstmöglich bei Ihnen.",
    "support.iframe.title": "Schicken Sie uns eine Nachricht",
    "support.iframe.subtitle": "Schicken Sie uns eine Nachricht. Wir melden uns schnellstmöglich bei Ihnen.",
    "support.phone.title": "Telefon",
    "support.phone.subtitle": "Telefonnummer und Öffnungszeiten des Kundenservice",
    "support.chat.title": "Chatten",
    "support.chat.subtitle": "Sie ohne Kundenbetreuung",
    "support.askAnother": "Neue Frage stellen",
    "support.error.title": "Etwas ist schiefgelaufen",
    "support.error.description": "Kontrollieren Sie bitte Ihre Internetverbindung und versuchen Sie nochmal",
    "form.title": "Frage stellen",
    "form.titleNew": "Neue Frage stellen",
    "form.placeholder": "Geben Sie hier Ihre Frage ein",
    "form.buttonLabel": "Frage abschicken",
    "form.clearInput": "Sucheingabe löschen",
    "form.validationError": "Sie müssen eine Frage stellen",
    "answer.supportLabel": "Hier können Sie unseren Kundenservice kontaktieren",
    "answer.showMore": "Mehr lesen",
    "answer.additionalContent.moreInfo": "Mehr Info",
    "answer.error.title": "Etwas ist schiefgelaufen...",
    "answer.error.description": "Kontrollieren Sie bitte Ihre Internetverbindung und versuchen Sie nochmal",
    "answers.a11y.summary": "Antwort [](index) von [](count)",
    "answers.a11y.tab": "Auf Antwort [](index) gehen",
    "answer.viewOriginal": "Originalantwort anzeigen",
    "answer.copy.originalAnswerLink": "Link zur Originalantwort kopieren",
    "noAnswer.label": "Wir können leider Ihre Frage nicht beantworten. \n \nVersuchen Sie bitte erneut zu fragen oder setzen Sie sich mit unserem Kundenservice in Kontakt.",
    "feedback.positive.label": "Ja",
    "feedback.positive.ariaLabel": "Diese Antwort hat mir weitergeholfen",
    "feedback.negative.label": "Nein",
    "feedback.negative.ariaLabel": "Diese Antwort hat mir nicht weitergeholfen",
    "feedback.label": "Ist diese Antwort hilfreich?",
    "feedback.label.reviewed": "Danke für Ihr Feedback",
    "success.title": "Danke für Ihr Feedback. Wir sind froh, Ihnen weiterhelfen zu können.",
    "success.button.title": "Zurück zur Antwort",
    "phone.title": "Rufen Sie uns an",
    "phone.subtitle": "Sie können uns gerne auf folgende Telefonnummer anrufen",
    "phone.openingHoursTitle": "Unsere Öffnungszeiten lauten:",
    "phone.askAnother": "Stellen Sie eine neue Frage",
    "phone.available": "Verfügbar",
    "phone.unavailable": "Nicht verfügbar",
    "email.title": "Schreiben Sie uns eine E-Mail",
    "email.subtitle": "Ihre Anfrage wird an einen unserer Mitarbeiter weitergegeben und wir werden schnellst möglich auf Sie zurückkommen.",
    "email.userEmailPlaceholder": "Schreiben Sie hier Ihre E-Mail-Adresse",
    "email.messagePlaceholder": "Schreiben Sie hier Ihre Nachricht",
    "email.error.title": "Die Nachricht konnte nicht zugestellt werden",
    "email.error.subtitle": "Bitte versuchen es Sie nochmal. Wenn der Fehler erneut auftritt, benutzen Sie bitte eine unserer anderen Kontaktmöglichkeiten.",
    "email.send": "Senden",
    "email.sending": "Nachricht wird gesendet...",
    "email.sendCopyToSelf": "Eine Blindkopie an mich schicken",
    "email.messageTemplate": "Lieber Kundenservice\n \nIch habe eine Frage: [](question)",
    "email.messageTemplatePostProcess": "Von: [](userEmail)\n \n[](message)",
    "emailSuccess.title": "Wir haben Ihre E-Mail erhalten",
    "emailSuccess.subtitle": "Ein_e Mitarbeiter_in wird Sie auf die von Ihnen angegebene E-Mail kontaktieren.",
    "emailSuccess.finish": "Fertig",
    "sidebar.close": "Schließen",
    "sidebar.originalLink": "Original ansehen",
    "topquestions.title": "Häufig gestellte Fragen",
    "topquestions.placeholder.heading": "Geben Sie eine Suchanfrage ein",
    "topquestions.placeholder.subheading": "Wir geben Ihnen umgehend eine Antwort",
    "globalError.description": "Etwas ist schief gelaufen",
    "globalError.retryButtonLabel": "Versuchen Sie nochmal",
    expand: "Mehr sehen",
    collapse: "Weniger sehen",
    copied: "Kopiert",
    copy: "Kopieren",
    open: "Offen",
    references: "Referenzen",
    "show.folder": "Ordner anzeigen",
    "poweredBy.label": "Powered by Raffle - Link zur Website",
    "gpt.disclaimer": "Die Zusammenfassung wurde von Raffles’ großen Sprachmodellen erstellt. Da sie fehlerhaft sein kann, finden Sie unten weitere Details in den ursprünglichen Suchergebnissen.",
    "chat.inputPlaceholder": "Geben Sie hier Ihre Frage ein",
    "chat.title": "Willkommen bei Raffle Chat!",
    "chat.description": "Sie können nach allem fragen, was für diese Website relevant ist - und Sie können im Freitext mit den Worten fragen, die Sie für richtig halten!\n \nWir hoffen, dass Sie alle Antworten finden, die Sie brauchen.",
    "chat.askMePrompt": "Frag mich irgendetwas...",
    "chat.topicTooltip": "Neues thema",
    "chat.regenerate": "Antwort erneut generieren",
    "chat.stopStream": "Generierung der Antwort stoppen",
    "chat.initialMessage": "Hallo! ✋ Wie kann ich Ihnen helfen?",
    "chat.inappropriateQuestionResponse": "Wir haben einige unangemessene Elemente in Ihrer Frage erkannt und können daher keine Antwort geben. Bitte formulieren Sie um oder fragen Sie etwas anderes.",
    "chat.noSearchResultsResponse": "Wir konnten keine relevanten Suchergebnisse zu Ihrer Frage finden. Versuchen Sie, Ihre Frage umzuformulieren oder fragen Sie etwas anderes.",
    "chat.retryErrorMessage": "Etwas ist schief gelaufen. Bitte versuchen Sie es in ein paar Augenblicken noch einmal.",
    "chat.searching.title": "Suche...",
    "chat.searching.description": "Relevante Ergebnisse finden",
    "header.title.results": "Ergebnisse",
    "header.title.answerPreview": "Antwortvorschau",
    "header.title.chat": "Chat",
    "header.title.support": "Kundendienst",
    "header.title.phoneSupport": "Telefonischer Kundendienst",
    "header.title.emailSupport": "E-mail Kundendienst",
    "navigation.search": "Suche",
    "cta.startConversation": "Beginnen Sie ein Gespräch",
    "search.noRelevantResults.title": "Wir haben keine relevanten Antworten gefunden.",
    "search.noRelevantResults.description": "Folgendes haben wir stattdessen gefunden.",
    "summary.title": "Zusammenfassung",
    "summary.disclaimer": "Zusammenfassung Haftungsausschluss",
    "searchpopup.gdpr": "DSGVO-Haftungsausschluss",
    "searchpopup.message": "Suchinformationen",
    toolbar: "Symbolleistenoptionen",
    "reference.open": "Offene Referenz",
    "feedback.title": "Ihr Feedback ist uns wichtig!",
    "feedback.subtitle": "Haben wir Ihre Frage beantwortet?",
    "feedback.commentTitle": "Vielen Dank für Ihr Feedback!",
    "feedback.commentSubtitle": "Ihre Meinung ist uns sehr wichtig.",
    "feedback.minimizedTitle": "Hallo! Wir würden uns sehr freuen, wenn Sie sich ein paar Sekunden Zeit nehmen würden, um unseren Self-Service zu bewerten.",
    "feedback.dismiss.text": "Überspringen",
    "feedback.commentButton.ariaLabel": "Kommentar senden",
    "feedback.comment.ariaLabel": "Kommentarfeld",
    "feedback.comment.label": "Haben Sie einen Kommentar?",
    "chat.activeNow": "Jetzt aktiv",
};
const fr = {
    "startButton.label": "Optenez une réponse rapide",
    "backButton.label": "Précédent",
    "closeButton.label": "Fermer",
    "initialPopover.title": "Cherchez-vous une réponse rapide?",
    "initialPopover.subtitle": "Cliquez ici, saisissez votre question et obtenez une réponse",
    "support.title": "Contactez notre service client",
    "support.subtitle": `Contactez notre service client via l'une des options ci-dessous`,
    "support.email.title": "Envoyez-nous un e-mail",
    "support.email.subtitle": "Envoyez-nous un e-mail et nous vous répondrons dans les plus brefs délais",
    "support.iframe.title": "Envoyez-nous un message",
    "support.iframe.subtitle": "​Envoyez-nous un message et nous vous répondrons dans les plus brefs délais",
    "support.phone.title": "Téléphone",
    "support.phone.subtitle": "​Voir notre numéro de téléphone et nos heures d'ouverture",
    "support.chat.title": "Discuter",
    "support.chat.subtitle": "avec notre service client​",
    "support.askAnother": "Posez une nouvelle question ",
    "support.error.title": "​Une erreur s'est produite ...",
    "support.error.description": "Vérifiez votre connexion réseau et réessayez",
    "form.title": "Demandez une question",
    "form.titleNew": "Demandez une nouvelle question ",
    "form.placeholder": "​Écrivez votre question ici",
    "form.buttonLabel": "Cherchez",
    "form.clearInput": "Effacer",
    "form.validationError": "Vous devez taper une question",
    "answer.supportLabel": "​Contactez notre service client ici",
    "answer.showMore": "Lire la suite",
    "answer.additionalContent.moreInfo": "Plus d'informations",
    "answer.error.title": "Une erreur s’est produite...",
    "answer.error.description": "​Vérifiez votre connexion réseau et réessayez",
    "answers.a11y.summary": "Réponse[](index) sur [](count)",
    "answers.a11y.tab": "Aller à la réponse [](index)",
    "answer.viewOriginal": "Voir l'original",
    "answer.copy.originalAnswerLink": "Lien vers la réponse originale",
    "noAnswer.label": "​Il semble que votre question ne soit pas couverte par les sujets auxquels nous pouvons répondre. \n \n​Essayez de demander à nouveau ou contactez le service client.",
    "feedback.positive.label": "Oui",
    "feedback.positive.ariaLabel": "​Cette réponse a été utile ",
    "feedback.negative.label": "Non",
    "feedback.negative.ariaLabel": "​Cette réponse n'a pas été utile",
    "feedback.label": "​Cette réponse vous a-t-elle été utile?",
    "feedback.label.reviewed": "​Merci pour vos commentaires",
    "success.title": "​Merci pour vos commentaires, nous sommes heureux que vous ayez pu utiliser la réponse.",
    "success.button.title": "Retour à la réponse",
    "phone.title": "​Appelez-nous",
    "phone.subtitle": "Vous êtes invités à nous appeler au",
    "phone.openingHoursTitle": `Nos heures d'ouverture sont:`,
    "phone.askAnother": "​Poser une nouvelle question",
    "phone.available": "​Disponible",
    "phone.unavailable": "​Indisponible",
    "email.title": "​Contactez-nous par e-mail",
    "email.subtitle": "Nous transmettrons votre question à l'un des membres de notre équipe, qui vous contactera dans les plus brefs délais.",
    "email.userEmailPlaceholder": "Écrivez votre email ici",
    "email.messagePlaceholder": "Ecrivez votre message ici​",
    "email.error.title": `Impossible d'envoyer le message`,
    "email.error.subtitle": `Réessayez et si le problème persiste, utilisez un autre de nos canaux d'assistance.`,
    "email.send": "​Envoyer",
    "email.sending": "​Envoi en cours...",
    "email.sendCopyToSelf": "​Envoyer une copie à moi-même",
    "email.messageTemplate": "Bonjour service client,\n \nJ’ai une question: [](question)",
    "email.messageTemplatePostProcess": "From: [](userEmail)\n \n[](message)",
    "emailSuccess.title": "​Nous avons reçu votre e-mail",
    "emailSuccess.subtitle": "Un membre de notre équipe vous contactera à l'adresse e-mail que vous avez fournie.",
    "emailSuccess.finish": "Finir",
    "sidebar.close": "Fermer",
    "sidebar.originalLink": "Voir l’original",
    "topquestions.title": "Questions fréquemment posées",
    "topquestions.placeholder.heading": "Entrez votre recherche",
    "topquestions.placeholder.subheading": "Nous vous donnerons une réponse immédiate",
    "globalError.description": "Une erreur s'est produite.",
    "globalError.retryButtonLabel": "Réessayez",
    expand: "Voir plus",
    collapse: "Voir moins",
    copied: "Copié",
    copy: "Copier",
    open: "Ouvert",
    references: "Références",
    "show.folder": "Afficher le dossier",
    "poweredBy.label": "Propulsé par",
    "gpt.disclaimer": "Le résumé a été généré par les grands modèles de langage de Raffles. Comme il peut être imparfait, veuillez consulter les résultats de recherche originaux ci-dessous pour plus de détails.",
    "chat.inputPlaceholder": "Écrivez votre question ici",
    "chat.title": "Bienvenue sur Raffle Chat !",
    "chat.description": "Vous pouvez poser des questions sur tout ce qui est pertinent pour ce site Web - et vous pouvez demander en texte libre en utilisant les mots que vous jugez appropriés!\n \n Nous espérons que vous trouverez toutes les réponses dont vous avez besoin.",
    "chat.askMePrompt": "Demandez-moi n’importe quoi...",
    "chat.topicTooltip": "Nouveau sujet",
    "chat.regenerate": "Régénérer la réponse",
    "chat.stopStream": "Arrêter la génération de la réponse",
    "chat.initialMessage": "Bonjour! ✋ Comment puis-je vous aider?",
    "chat.inappropriateQuestionResponse": `Nous avons détecté des éléments inappropriés dans votre question et ne pouvons donc pas fournir de réponse. Veuillez reformuler ou demander autre chose.`,
    "chat.noSearchResultsResponse": `Nous n'avons trouvé aucun résultat de recherche pertinent pour votre question. Essayez de reformuler votre question ou demandez autre chose.`,
    "chat.retryErrorMessage": "Quelque chose s'est mal passé. Merci de réessayer dans quelques instants.",
    "chat.searching.title": "Recherche...",
    "chat.searching.description": "Recherche de résultats pertinents",
    "header.title.results": "Résultats",
    "header.title.answerPreview": "Aperçu de la réponse",
    "header.title.chat": "Chat",
    "header.title.support": "Assistance",
    "header.title.phoneSupport": "Assistance Téléphonique",
    "header.title.emailSupport": "Assistance par E-mail",
    "navigation.search": "Cherhe",
    "cta.startConversation": "Commencer une conversation",
    "search.noRelevantResults.title": "Nous n'avons trouvé aucune réponse pertinente.",
    "search.noRelevantResults.description": "Voici ce que nous avons trouvé à la place.",
    "summary.title": "Résumé",
    "summary.disclaimer": "Avis de non-responsabilité",
    "searchpopup.gdpr": "Avertissement RGPD",
    "searchpopup.message": "Informations sur la recherche",
    toolbar: "Options de la barre d'outils",
    "reference.open": "Ouvrir la référence",
    "feedback.title": "Vos commentaires sont importants !",
    "feedback.subtitle": "Avons-nous répondu à votre question ?",
    "feedback.commentTitle": "Merci pour votre retour !",
    "feedback.commentSubtitle": "Nous apprécions grandement votre avis.",
    "feedback.minimizedTitle": "Bonjour ! Nous apprécierions grandement que vous preniez quelques secondes pour évaluer notre libre-service.",
    "feedback.dismiss.text": "Sauter",
    "feedback.commentButton.ariaLabel": "Envoyer le commentaire",
    "feedback.comment.ariaLabel": "Champ de commentaire",
    "feedback.comment.label": "Avez-vous un commentaire ?",
    "chat.activeNow": "Actif maintenant",
};
const sv = {
    "startButton.label": "Få svar snabbt",
    "backButton.label": "Tillbaka",
    "closeButton.label": "Stäng",
    "initialPopover.title": "Letar du efter ett snabbt svar?",
    "initialPopover.subtitle": "Klicka här, ange en fråga och få svar.",
    "support.title": "Kontakta vår kundtjänst",
    "support.subtitle": "Kontakta vår kundtjänst via ett av alternativen nedan",
    "support.email.title": "Skicka oss ett mail",
    "support.email.subtitle": "Skicka oss ett mail och vi kontaktar dig så snart som möjligt",
    "support.iframe.title": "Skicka oss ett meddelande",
    "support.iframe.subtitle": "Skicka oss ett meddelande och vi kontaktar dig så snart som möjligt",
    "support.phone.title": "Telefon",
    "support.phone.subtitle": "Se vårt telefonnummer och öppettider för kundtjänst",
    "support.chat.title": "Chat",
    "support.chat.subtitle": "med vår kundtjänst",
    "support.askAnother": "Ställ en ny fråga",
    "support.error.title": "Något gick fel",
    "support.error.description": "Kontrollera din internetanslutning och försök igen",
    "form.title": "Ställ en fråga",
    "form.titleNew": "Ställ en ny fråga",
    "form.placeholder": "Skriv din fråga här",
    "form.buttonLabel": "Sök",
    "form.clearInput": "Rensa",
    "form.validationError": "Du måste ställa en fråga",
    "answer.supportLabel": "Kontakta vår kundtjänst här",
    "answer.showMore": "Läs mer",
    "answer.additionalContent.moreInfo": "Mer information",
    "answer.error.title": "Något gick fel...",
    "answer.error.description": "Kontrollera din internetanslutning och försök igen",
    "answers.a11y.summary": "Svar [](index) av [](count)",
    "answers.a11y.tab": "Gå till svaret [](index)",
    "answer.viewOriginal": "Visa original",
    "answer.copy.originalAnswerLink": "Kopiera länk till original",
    "noAnswer.label": "Det verkar som om din fråga inte täcks av de ämnen som vi kan svara på. \n \nFörsök att fråga igen eller kontakta kundtjänst.",
    "feedback.positive.label": "Ja",
    "feedback.positive.ariaLabel": "Detta svar var hjälpsamt",
    "feedback.negative.label": "Nej",
    "feedback.negative.ariaLabel": "Detta svar var inte hjälpsamt",
    "feedback.label": "Var detta svar hjälpsamt?",
    "feedback.label.reviewed": "Tack för din feedback",
    "success.title": "Tack för din feedback. Vi är glada för, att du kunde använda svaret.",
    "success.button.title": "Tillbaka till svaret",
    "phone.title": "Ring oss",
    "phone.subtitle": "Du är välkommen att ringa oss på",
    "phone.openingHoursTitle": "Våra öppettider är:",
    "phone.askAnother": "Ställ en ny fråga",
    "phone.available": "Tillgänglig",
    "phone.unavailable": "Otillgänglig",
    "email.title": "Kontakta oss via e-post",
    "email.subtitle": "Vi skickar din fråga till en från vårt team som kontaktar dig så snart som möjligt.",
    "email.userEmailPlaceholder": "Ange din e-postadress här",
    "email.messagePlaceholder": "Skriv meddelandet här",
    "email.error.title": "Det gick inte att skicka meddelandet",
    "email.error.subtitle": "Försök igen, och om problemet kvarstår, använd ett av de andra kontaktalternativen.",
    "email.send": "Skicka",
    "email.sending": "Skickar…",
    "email.sendCopyToSelf": "Skicka kopia till mig själv",
    "email.messageTemplate": "Hej kundtjänst\n \nJag har en fråga: [](question)",
    "email.messageTemplatePostProcess": "Från: [](userEmail)\n \n[](message)",
    "emailSuccess.title": "Vi har mottagen ditt meddelande",
    "emailSuccess.subtitle": "En från vårt team kommer att kontakta dig på den e-postadress du angav.",
    "emailSuccess.finish": "Avsluta",
    "sidebar.close": "Stäng",
    "sidebar.originalLink": "Se original",
    "topquestions.title": "Vanliga frågor",
    "topquestions.placeholder.heading": "Ange en sökfråga",
    "topquestions.placeholder.subheading": "Vi ger dig ett omedelbart svar",
    "globalError.description": "Något gick fel.",
    "globalError.retryButtonLabel": "Försök igen",
    expand: "Se mer",
    collapse: "Se mindre",
    copied: "Kopieras",
    copy: "Kopiera",
    open: "Öppna",
    references: "Referenser",
    "show.folder": "Visa mapp",
    "poweredBy.label": "Powered by Raffle - länk till raffle",
    "gpt.disclaimer": "Sammanfattningen genererades av Raffles stora språkmodeller. Eftersom det kan vara felaktigt, se de ursprungliga sökresultaten nedan för ytterligare detaljer.",
    "chat.inputPlaceholder": "Skriv din fråga här",
    "chat.title": "Välkommen till Raffle Chat!",
    "chat.description": "Du kan fråga om allt som är relevant för denna webbplats - och du kan fråga i fri text med de ord du tycker passar!\n \nVi hoppas att du hittar alla svar du behöver.",
    "chat.askMePrompt": "Fråga mig vad som helst ...",
    "chat.topicTooltip": "Nytt ämne",
    "chat.regenerate": "Generera svar igen",
    "chat.stopStream": "Stoppa generering av svar",
    "chat.initialMessage": "Hej där! ✋ Hur kan jag hjälpa dig?",
    "chat.inappropriateQuestionResponse": `Vi har upptäckt några olämpliga element i din fråga och kan därför inte ge ett svar. Var god formulera om eller fråga något annat.`,
    "chat.noSearchResultsResponse": `Vi kunde inte hitta några relevanta sökresultat till din fråga. Försök formulera om din fråga eller fråga något annat.`,
    "chat.retryErrorMessage": "Något gick fel. Försök igen om några ögonblick.",
    "chat.searching.title": "Söker ...",
    "chat.searching.description": "Hittar relevanta resultat",
    "header.title.results": "Resultat",
    "header.title.answerPreview": "Svarsförhandsgranskning",
    "header.title.chat": "Chat",
    "header.title.support": "Kundsupport",
    "header.title.phoneSupport": "Telefonsupport",
    "header.title.emailSupport": "E-postsupport",
    "navigation.search": "Sök",
    "cta.startConversation": "Starta en konversation",
    "search.noRelevantResults.title": "Vi hittade inga relevanta svar.",
    "search.noRelevantResults.description": "Här är vad vi hittade istället.",
    "summary.title": "Sammanfattning",
    "summary.disclaimer": "Sammanfattningsfriskrivning",
    "searchpopup.gdpr": "GDPR-friskrivning",
    "searchpopup.message": "Information om sökning",
    toolbar: "Verktygsfältsalternativ",
    "reference.open": "Öppen referens",
    "feedback.title": "Din feedback är viktig!",
    "feedback.subtitle": "Besvarade vi din fråga?",
    "feedback.commentTitle": "Tack för din feedback!",
    "feedback.commentSubtitle": "Vi uppskattar mycket din åsikt.",
    "feedback.minimizedTitle": "Hej! Vi skulle uppskatta om du tog några sekunder att betygsätta vår självbetjäning.",
    "feedback.dismiss.text": "Hoppa",
    "feedback.commentButton.ariaLabel": "Skicka kommentar",
    "feedback.comment.ariaLabel": "Kommentarfält",
    "feedback.comment.label": "Har du en kommentar?",
    "chat.activeNow": "Aktiv nu",
};
const no = {
    "startButton.label": "Få svar raskt",
    "backButton.label": "Tilbake",
    "closeButton.label": "Lukk",
    "initialPopover.title": "Leter du etter et raskt svar?",
    "initialPopover.subtitle": "Klikk her, skriv inn et spørsmål og få svar.",
    "support.title": "Kontakt vår kundeservice",
    "support.subtitle": "Kontakt vår kundeservice via ett av alternativene nedenfor",
    "support.email.title": "Send oss en e-post",
    "support.email.subtitle": "Send oss en e-post så kommer vi tilbake til deg så snart som mulig",
    "support.iframe.title": "Send oss en melding",
    "support.iframe.subtitle": "Send oss en melding så kommer vi tilbake til deg så snart som mulig",
    "support.phone.title": "Telefon",
    "support.phone.subtitle": "Se vårt telefonnummer og åpningstider for kundeservice",
    "support.chat.title": "Chat",
    "support.chat.subtitle": "med vår kundeservice",
    "support.askAnother": "Still et nytt spørsmål",
    "support.error.title": "Noe gikk galt",
    "support.error.description": "Sjekk Internett-tilkoblingen din og prøv igjen",
    "form.title": "Spør et spørsmål",
    "form.titleNew": "Still et nytt spørsmål",
    "form.placeholder": "Skriv spørsmålet ditt her",
    "form.buttonLabel": "Spørre",
    "form.clearInput": "Clear search query",
    "form.validationError": "Du må stille et spørsmål",
    "answer.supportLabel": "Kontakt vår kundeservice her",
    "answer.showMore": "Les mer",
    "answer.additionalContent.moreInfo": "Mer info",
    "answer.error.title": "Noe gikk galt...",
    "answer.error.description": "Sjekk Internett-tilkoblingen din og prøv igjen",
    "answers.a11y.summary": "Svar [](index) av [](count)",
    "answers.a11y.tab": "Gå til svar [](index)",
    "answer.viewOriginal": "View original answer",
    "answer.copy.originalAnswerLink": "Copy link to original answer",
    "noAnswer.label": "Det ser ut til at spørsmålet ditt ikke dekkes av emnene vi kan svare på. \n \nPrøv å spørre igjen eller kontakt kundeservice.",
    "feedback.positive.label": "Ja",
    "feedback.positive.ariaLabel": "Dette svaret var nyttig",
    "feedback.negative.label": "Nej",
    "feedback.negative.ariaLabel": "Dette svaret var ikke nyttig",
    "feedback.label": "Var dette svaret nyttig?",
    "feedback.label.reviewed": "Takk for din tilbakemelding",
    "success.title": "Takk for din tilbakemelding. Vi er glade for at du kunne bruke svaret.",
    "success.button.title": "Gå tilbake til svar",
    "phone.title": "Ring oss",
    "phone.subtitle": "Du er velkommen til å ringe",
    "phone.openingHoursTitle": "Våre åpningstider er:",
    "phone.askAnother": "Still et nytt spørsmål",
    "phone.available": "Tilgjengelig",
    "phone.unavailable": "Ikke tilgjengelig",
    "email.title": "Kontakt oss på e-post",
    "email.subtitle": "Vi vil videresende spørsmålet ditt til en i teamet vårt, som vil kontakte deg så snart som mulig.",
    "email.userEmailPlaceholder": "Skriv din e-post her",
    "email.messagePlaceholder": "Skriv meldingen her",
    "email.error.title": "Kunne ikke sende melding",
    "email.error.subtitle": "Prøv igjen, og hvis problemet vedvarer, bruk et av de andre kontaktalternativene.",
    "email.send": "Sende",
    "email.sending": "Sender...",
    "email.sendCopyToSelf": "Send kopi til meg selv",
    "email.messageTemplate": "Hei kundeservice\n \nJeg har et spørsmål: [](question)",
    "email.messageTemplatePostProcess": "Fra: [](userEmail)\n \n[](message)",
    "emailSuccess.title": "Vi har mottatt e-posten din",
    "emailSuccess.subtitle": "En i teamet vårt vil kontakte deg på e-postadressen du oppga.",
    "emailSuccess.finish": "Avslutt",
    "sidebar.close": "Lukk",
    "sidebar.originalLink": "Se original",
    "topquestions.title": "Ofte stilte spørsmål",
    "topquestions.placeholder.heading": "Skriv inn et søk",
    "topquestions.placeholder.subheading": "Vi vil gi deg et umiddelbart svar",
    "globalError.description": "Noe gikk galt.",
    "globalError.retryButtonLabel": "Vennligst prøv igjen",
    expand: "Se mer",
    collapse: "Se mindre",
    copied: "Kopiert",
    copy: "Kopi",
    open: "Åpne",
    references: "Referanser",
    "show.folder": "Vis mappe",
    "poweredBy.label": "Powered by Raffle - link to website",
    "gpt.disclaimer": "Sammendraget er generert og kan være feilaktig. Se de orginale søkeresultatene under for ytterligere detaljer.",
    "chat.inputPlaceholder": "Skriv inn spørsmålet ditt her",
    "chat.title": "Velkommen til Raffle Chat!",
    "chat.description": "Du kan spørre om alt som er relevant for denne nettsiden - og du kan spørre i fritekst med de ordene du synes passer!\n \nVi håper du finner alle svarene du trenger.",
    "chat.askMePrompt": "Spør meg om hva som helst...",
    "chat.topicTooltip": "Nytt emne",
    "chat.regenerate": "Generer svar på nytt",
    "chat.stopStream": "Stopp generering av svar",
    "chat.initialMessage": "Hei! ✋ Hvordan kan jeg hjelpe deg?",
    "chat.inappropriateQuestionResponse": `Vi har oppdaget noen upassende elementer i spørsmålet ditt og kan derfor ikke gi et svar. Vennligst omformuler eller spør om noe annet.`,
    "chat.retryErrorMessage": "Noe gikk galt. Prøv igjen om noen få øyeblikk.",
    "chat.noSearchResultsResponse": `Vi fant ingen relevante søkeresultater for spørsmålet ditt. Prøv å omformulere spørsmålet ditt eller spør om noe annet.`,
    "chat.searching.title": "Søker ...",
    "chat.searching.description": "Finner relevante resultater",
    "header.title.results": "Resultater",
    "header.title.answerPreview": "Forhåndsvisning av svar",
    "header.title.chat": "Chat",
    "header.title.support": "Kundeservice",
    "header.title.phoneSupport": "Telefonstøtte",
    "header.title.emailSupport": "E-poststøtte",
    "navigation.search": "Søk",
    "cta.startConversation": "Start en samtale",
    "search.noRelevantResults.title": "Vi fant ingen relevante svar.",
    "search.noRelevantResults.description": "Her er hva vi fant i stedet.",
    "summary.title": "Sammendrag",
    "summary.disclaimer": "Sammendragsfraskrivelse",
    "searchpopup.gdpr": "GDPR ansvarsfraskrivelse",
    "searchpopup.message": "Informasjon om søk",
    toolbar: "Verktøylinjealternativer",
    "reference.open": "Åpen referanse",
    "feedback.title": "Din tilbakemelding er viktig!",
    "feedback.subtitle": "Svarte vi på spørsmålet ditt?",
    "feedback.commentTitle": "Takk for tilbakemeldingen!",
    "feedback.commentSubtitle": "Vi setter stor pris på din mening.",
    "feedback.minimizedTitle": "Hei! Vi vil sette stor pris på om du vil bruke noen sekunder på å vurdere selvbetjeningen vår.",
    "feedback.dismiss.text": "Hopp over",
    "feedback.commentButton.ariaLabel": "Send kommentar",
    "feedback.comment.ariaLabel": "Kommentarfelt",
    "feedback.comment.label": "Har du en kommentar?",
    "chat.activeNow": "Aktiv nå",
};
const pl = {
    "startButton.label": "Uzyskaj szybką odpowiedź",
    "backButton.label": "Wróć",
    "closeButton.label": "Zamknij",
    "initialPopover.title": "Czy szukasz szybkiej odpowiedzi?",
    "initialPopover.subtitle": "Kliknij tutaj, wpisz swoje pytanie i uzyskaj odpowiedź",
    "support.title": "Skontaktuj się z naszym Biurem Obsługi Klienta",
    "support.subtitle": "Skontaktuj się z naszym Biurem Obsługi Klienta, korzystając z jednej z poniższych opcji",
    "support.email.title": "Wyślij do nas e-mail",
    "support.email.subtitle": "Wyślij do nas e-mail, a my skontaktujemy się z Tobą tak szybko jak to możliwe",
    "support.iframe.title": "Wyślij nam wiadomość",
    "support.iframe.subtitle": "Wyślij nam wiadomość, a my skontaktujemy się z Tobą tak szybko jak to możliwe",
    "support.phone.title": "Telefon",
    "support.phone.subtitle": "Sprawdź nasz numer telefonu i godziny otwarcia",
    "support.chat.title": "Czat",
    "support.chat.subtitle": "Z naszym Biurem Obsługi Klienta",
    "support.askAnother": "Zadaj nowe pytanie",
    "support.error.title": "Coś poszło nie tak...",
    "support.error.description": "Sprawdź połączenie sieciowe i spróbuj ponownie",
    "form.title": "Zadaj pytanie",
    "form.titleNew": "Zadaj nowe pytanie",
    "form.placeholder": "Napisz swoje pytanie tutaj",
    "form.buttonLabel": "Szukaj",
    "form.clearInput": "Wyczyść",
    "form.validationError": "Musisz wpisać pytanie",
    "answer.supportLabel": "Tutaj skontaktuj się z naszym Biurem Obsługi Klienta",
    "answer.showMore": "Zobacz więcej",
    "answer.additionalContent.moreInfo": "Więcej informacji",
    "answer.error.title": "Coś poszło nie tak...",
    "answer.error.description": "Sprawdź połączenie sieciowe i spróbuj ponownie",
    "answers.a11y.summary": "Odpowiedź [](indeks) of [](count)",
    "answers.a11y.tab": "Idź do odpowiedzi [](indeks)",
    "answer.viewOriginal": "Zobacz źródłową odpowiedź",
    "answer.copy.originalAnswerLink": "Skopiuj link do odpowiedzi",
    "noAnswer.label": "Wygląda na to, że Twoje pytanie nie jest objęte tematami, na które możemy odpowiedzieć. \n \n Spróbuj zapytać ponownie lub skontaktuj się z Biurem Obsługi Klienta.",
    "feedback.positive.label": "Tak",
    "feedback.positive.ariaLabel": "Ta odpowiedź była pomocna",
    "feedback.negative.label": "Nie",
    "feedback.negative.ariaLabel": "Ta odpowiedź nie była pomocna",
    "feedback.label": "Czy ta odpowiedź była pomocna?",
    "feedback.label.reviewed": "Dziękujemy za opinie",
    "success.title": "Dziękujemy za Twoją opinię, cieszymy się, że odpowiedź była pomocna.",
    "success.button.title": "Wróć do odpowiedzi",
    "phone.title": "Zadzwoń do nas",
    "phone.subtitle": "Zachęcamy do kontaktu",
    "phone.openingHoursTitle": "Nasze godziny otwarcia to:",
    "phone.askAnother": "Zadaj nowe pytanie",
    "phone.available": "Dostępny",
    "phone.unavailable": "Niedostępny",
    "email.title": "Skontaktuj się z nami przez e-mail",
    "email.subtitle": "Twoje pytanie przekażemy jednemu z członków naszego zespołu, który jak najszybciej skontaktuje się z Tobą.",
    "email.userEmailPlaceholder": "Tutaj wpisz swój e-mail",
    "email.messagePlaceholder": "Tutaj wpisz swoją wiadomość",
    "email.error.title": "Nie można wysłać wiadomości",
    "email.error.subtitle": "Spróbuj ponownie, a jeśli problem będzie się powtarzał, skorzystaj z innego z naszych kanałów pomocy.",
    "email.send": "Wyślij",
    "email.sending": "Wysyłanie...",
    "email.sendCopyToSelf": "Wyślij kopię do siebie",
    "email.messageTemplate": "Cześć Biuro Obsługi Klienta,\n \n Mam pytanie: [](question)",
    "email.messageTemplatePostProcess": "Od: [](userEmail)\n \n[](message)",
    "emailSuccess.title": "Otrzymaliśmy Twój e-mail",
    "emailSuccess.subtitle": "Członek naszego zespołu skontaktuje się z Tobą na podany przez Ciebie adres e-mail.",
    "emailSuccess.finish": "Koniec",
    "sidebar.close": "Zamknij",
    "sidebar.originalLink": "Zobacz oryginał",
    "topquestions.title": "Często Zadawane Pytania",
    "topquestions.placeholder.heading": "Wpisz pytanie",
    "topquestions.placeholder.subheading": "Udzielimy Ci natychmiastowej odpowiedzi",
    "globalError.description": "Coś poszło nie tak.",
    "globalError.retryButtonLabel": "Spróbuj ponownie",
    expand: "Rozwiń",
    collapse: "Zwiń",
    copied: "Kopiowane",
    copy: "Kopiuj",
    open: "Otwórz",
    references: "Odnośniki",
    "show.folder": "Pokaż folder",
    "poweredBy.label": "Powered by Raffle - link do strony internetoweje",
    "gpt.disclaimer": "Podsumowanie zostało wygenerowane przez duże modele językowe Raffles. Ponieważ może być wadliwe, zapoznaj się z oryginalnymi wynikami wyszukiwania poniżej, aby uzyskać więcej szczegółów.",
    "chat.inputPlaceholder": "Wpisz swoje pytanie tutaj",
    "chat.title": "Witamy na czacie Raffle!",
    "chat.description": "Możesz zapytać o wszystko, co jest istotne dla tej strony - i możesz zapytać w wolnym tekście, używając słów, które uznasz za stosowne!\n \nMamy nadzieję, że znajdziesz wszystkie odpowiedzi, których potrzebujesz.",
    "chat.askMePrompt": "Zapytaj mnie o cokolwiek...",
    "chat.topicTooltip": "Nowy temat",
    "chat.regenerate": "Wygeneruj odpowiedź ponownie",
    "chat.stopStream": "Zatrzymaj generowanie odpowiedzi",
    "chat.initialMessage": "Cześć! ✋ Jak mogę Ci pomóc?",
    "chat.inappropriateQuestionResponse": `Wykryliśmy nieodpowiednie elementy w Twoim pytaniu i dlatego nie możemy udzielić odpowiedzi. Proszę przeformułuj lub zapytaj o coś innego.`,
    "chat.noSearchResultsResponse": `Nie znaleźliśmy żadnych odpowiednich wyników wyszukiwania dla Twojego pytania. Spróbuj przeformułować swoje pytanie lub zapytać o coś innego.`,
    "chat.retryErrorMessage": "Coś poszło nie tak. Spróbuj ponownie za kilka chwil.",
    "chat.searching.title": "Wyszukiwanie...",
    "chat.searching.description": "Wyszukiwanie odpowiednich wyników",
    "header.title.results": "Wyniki",
    "header.title.answerPreview": "Podgląd odpowiedzi",
    "header.title.chat": "Chat",
    "header.title.support": "Obsługa klienta",
    "header.title.phoneSupport": "Telefoniczna obsługa klienta",
    "header.title.emailSupport": "Wyślij e-mail do obsługi klienta",
    "navigation.search": "Szukaj",
    "cta.startConversation": "Rozpocząć rozmowę",
    "search.noRelevantResults.title": "Nie znaleźliśmy żadnych trafnych odpowiedzi.",
    "search.noRelevantResults.description": "Oto, co znaleźliśmy zamiast tego.",
    "summary.title": "Streszczenie",
    "summary.disclaimer": "Informacja o podsumowaniu",
    "searchpopup.gdpr": "Informacja o RODO",
    "searchpopup.message": "Wynik wyszukiwania",
    toolbar: "Ustawienia paska narzędzi",
    "reference.open": "Otwórz referencję",
    "feedback.title": "Twoja opinia jest ważna!",
    "feedback.subtitle": "Czy odpowiedzieliśmy na Twoje pytanie?",
    "feedback.commentTitle": "Dziękujemy za Twoją opinię!",
    "feedback.commentSubtitle": "Bardzo nam zależy na Twoim zdaniu.",
    "feedback.minimizedTitle": "Cześć! 😊 Bylibyśmy bardzo wdzięczni za poświęcenie kilku sekund na ocenę naszej usługi.",
    "feedback.dismiss.text": "Pominąć",
    "feedback.commentButton.ariaLabel": "Wyślij komentarz",
    "feedback.comment.ariaLabel": "Pole komentarza",
    "feedback.comment.label": "Czy masz komentarz?",
    "chat.activeNow": "Aktywny teraz",
};
const nl = {
    "startButton.label": "Krijg snel een antwoord",
    "backButton.label": "Terug",
    "closeButton.label": "Afsluiten",
    "initialPopover.title": "Snel een antwoord?",
    "initialPopover.subtitle": "Klik hier, stel je vraag in en krijg een antwoord",
    "support.title": "Neem contact met ons op",
    "support.subtitle": "Neem contact met ons op via een van de onderstaande opties",
    "support.email.title": "Mail ons",
    "support.email.subtitle": "Stuur ons een mail en wij beantwoorden u zo snel mogelijk",
    "support.iframe.title": "Stuur ons een bericht",
    "support.iframe.subtitle": "Stuur ons een bericht en wij beantwoorden u zo snel mogelijk",
    "support.phone.title": "Telefoon",
    "support.phone.subtitle": "Bekijk ons telefoonnummer en onze openingstijden",
    "support.chat.title": "Chat",
    "support.chat.subtitle": "met onze klantenservice",
    "support.askAnother": "Stel een nieuwe vraag",
    "support.error.title": "Er is iets misgegaan…",
    "support.error.description": "Controleer uw netwerkverbinding en probeer opnieuw",
    "form.title": "Stel een vraag",
    "form.titleNew": "Stel een nieuwe vraag",
    "form.placeholder": "Stel je vraag hier",
    "form.buttonLabel": "Zoeken",
    "form.clearInput": "Wis zoekopdracht",
    "form.validationError": "Stel uw vraag",
    "answer.supportLabel": "Neem contact op met onze klantenservice",
    "answer.showMore": "Lees meer",
    "answer.additionalContent.moreInfo": "Meer info",
    "answer.error.title": "Er is iets misgegaan…",
    "answer.error.description": "Controleer uw netwerkverbinding en probeer opnieuw",
    "answers.a11y.summary": "Antwoord  [](index) van (count)",
    "answers.a11y.tab": "Ga naar antwoord [](index)",
    "answer.viewOriginal": "Bekijk oorspronkelijke antwoord",
    "answer.copy.originalAnswerLink": "Kopieer de link met oorspronkelijk antwoord",
    "noAnswer.label": "Het lijkt erop dat uw vraag niet deel uitmaakt van de onderwerpen waarop wij kunnen antwoorden. Probeer uw vraag opnieuw te stellen of neem contact met ons op.",
    "feedback.positive.label": "Ja",
    "feedback.positive.ariaLabel": "Dit antwoord heeft geholpen",
    "feedback.negative.label": "Nee",
    "feedback.negative.ariaLabel": "Dit antwoord heeft niet geholpen",
    "feedback.label": "Heeft dit antwoord geholpen?",
    "feedback.label.reviewed": "Bedankt voor uw feedback",
    "success.title": "Bedankt voor uw feedback, we zijn blij dat uw vraag is beantwoord",
    "success.button.title": "Terug naar het antwoord",
    "phone.title": "Bel ons",
    "phone.subtitle": "Aarzel niet om ons te bellen",
    "phone.openingHoursTitle": "Onze openingstijden zijn:",
    "phone.askAnother": "Stel een nieuwe vraag",
    "phone.available": "Beschikbaar",
    "phone.unavailable": "Niet beschikbaar",
    "email.title": "Contacteer ons via mail",
    "email.subtitle": "We geven uw vraag door aan onze medewerkers die u zo snel mogelijk zullenl contacteren",
    "email.userEmailPlaceholder": "Vul uw e-mailadres in",
    "email.messagePlaceholder": "Schrijf uw bericht hier",
    "email.error.title": "Niet in staat om dit bericht te versturen",
    "email.error.subtitle": "Probeer opnieuw en als het probleem aanhoudt, gebruik dan onze andere contactmogelijkheden",
    "email.send": "Verzend mail",
    "email.sending": "Aan het verzenden…",
    "email.sendCopyToSelf": "Stuur een kopie naar mijzelf",
    "email.messageTemplate": "Hallo klantenservice,\n \nl heb een vraag: [](question)",
    "email.messageTemplatePostProcess": "Van: [](userEmail)\n \n[](message)",
    "emailSuccess.title": "We hebben uw mail ontvangen",
    "emailSuccess.subtitle": "Een medewerker zal u contacteren op het door u opgegeven e-mailadres",
    "emailSuccess.finish": "Klaar",
    "sidebar.close": "Sluit",
    "sidebar.originalLink": "Bekijk het originele",
    "topquestions.title": "Veelgestelde Vragen",
    "topquestions.placeholder.heading": "Voer een zoekopdracht in",
    "topquestions.placeholder.subheading": "Wij geven u direct een reactie",
    "globalError.description": "Er is iets misgegaan",
    "globalError.retryButtonLabel": "Probeer opnieuw",
    expand: "Lees meer",
    collapse: "Lees minder",
    copied: "Gekopieerd",
    copy: "Kopieer",
    open: "Open",
    references: "Referenties",
    "show.folder": "Bekijk folder",
    "poweredBy.label": "Mogelijk gemaakt door Raffle - link naar website",
    "gpt.disclaimer": "Deze samenvatting is gegenereerd door de taalmodellen van Raffle. Zie de artikelen hieronder indien het antwoord niet passend is.",
    "chat.inputPlaceholder": "Stel uw vraag hier",
    "chat.title": "Welkom bij Raffle Chat!",
    "chat.description": "U kunt vragen stellen over alles wat relevant is voor deze website - en u kunt vragen in vrije tekst met behulp van de woorden die u geschikt acht!\n \nWe hopen dat je alle antwoorden vindt die je nodig hebt.",
    "chat.askMePrompt": "Vraag me alles...",
    "chat.topicTooltip": "Nieuw onderwerp",
    "chat.regenerate": "Genereer antwoord opnieuw",
    "chat.stopStream": "Stop met het genereren van antwoorden",
    "chat.initialMessage": "Hallo! ✋ Hoe kan ik u helpen?",
    "chat.inappropriateQuestionResponse": `We hebben enkele ongepaste elementen in uw vraag gedetecteerd en kunnen daarom geen antwoord geven. Gelieve te herformuleren of iets anders te vragen.`,
    "chat.noSearchResultsResponse": `We konden geen relevante zoekresultaten vinden voor uw vraag. Probeer uw vraag te herformuleren of vraag iets anders.`,
    "chat.retryErrorMessage": "Er is iets fout gegaan. Probeer het over enkele ogenblikken opnieuw.",
    "chat.searching.title": "Zoeken...",
    "chat.searching.description": "Relevante resultaten vinden",
    "header.title.results": "Resultaten",
    "header.title.answerPreview": "Antwoordvoorbeeld",
    "header.title.chat": "Chat",
    "header.title.support": "Klantenservice",
    "header.title.phoneSupport": "Telefoonondersteuning",
    "header.title.emailSupport": "E-mailondersteuning",
    "navigation.search": "Zoekopdracht",
    "cta.startConversation": "Een gesprek beginnen",
    "search.noRelevantResults.title": "We hebben geen relevante antwoorden gevonden.",
    "search.noRelevantResults.description": "Dit is wat we in plaats daarvan hebben gevonden.",
    "summary.title": "Samenvatting",
    "summary.disclaimer": "Samenvatting disclaimer",
    "searchpopup.gdpr": "GDPR disclaimer",
    "searchpopup.message": "Zoekbericht",
    toolbar: "Toolbar opties",
    "reference.open": "Open referentie",
    "feedback.title": "Jouw feedback is belangrijk!",
    "feedback.subtitle": "Hebben we je vraag beantwoord?",
    "feedback.commentTitle": "Bedankt voor je feedback!",
    "feedback.commentSubtitle": "We waarderen je mening enorm!",
    "feedback.minimizedTitle": "Hallo, we zouden het op prijs stellen als je een paar seconden wilt gebruiken om onze self-service te beoordelen",
    "feedback.dismiss.text": "Overslaan",
    "feedback.commentButton.ariaLabel": "Commentaar verzenden",
    "feedback.comment.ariaLabel": "Commentaarveld",
    "feedback.comment.label": "Heeft u een opmerking?",
    "chat.activeNow": "Nu actief",
};
const fi = {
    "startButton.label": "Saa nopea vastaus",
    "backButton.label": "Takaisin",
    "closeButton.label": "Sulje",
    "initialPopover.title": "Etsitkö nopeaa vastausta?",
    "initialPopover.subtitle": "Klikkaa tästä, kirjoita kysymyksesi ja saat vastauksen",
    "support.title": "Ota yhteyttä asiakaspalveluumme",
    "support.subtitle": "Ota yhteyttä asiakaspalveluumme jollakin alla olevista vaihtoehdoista",
    "support.email.title": "Lähetä meille sähköpostia",
    "support.email.subtitle": "Lähetä meille sähköpostia, ja otamme sinuun yhteyttä mahdollisimman pian",
    "support.iframe.title": "Lähetä meille viesti",
    "support.iframe.subtitle": "Lähetä meille viesti, ja otamme sinuun yhteyttä mahdollisimman pian",
    "support.phone.title": "Puhelin",
    "support.phone.subtitle": "Katso puhelinnumeromme ja aukioloajat",
    "support.chat.title": "Keskustelu",
    "support.chat.subtitle": "asiakastukemme kanssa",
    "support.askAnother": "Kysy uusi kysymys",
    "support.error.title": "Jotain",
    "support.error.description": "Tarkista verkkoyhteytesi ja yritä uudelleen",
    "form.title": "Kysy kysymys",
    "form.titleNew": "Kysy uusi kysymys",
    "form.placeholder": "Kirjoita kysymyksesi tähän",
    "form.buttonLabel": "Kysy",
    "form.clearInput": "Tyhjennä hakukysely",
    "form.validationError": "Sinun on kirjoitettava kysymys",
    "answer.supportLabel": "Ota yhteyttä asiakaspalveluumme tästä",
    "answer.showMore": "Lue lisää",
    "answer.additionalContent.moreInfo": "Lisätietoja",
    "answer.error.title": "Jotain",
    "answer.error.description": "Tarkista verkkoyhteytesi ja yritä uudelleen",
    "answers.a11y.summary": "Vastaus [](indeksi) / [](määrä)",
    "answers.a11y.tab": "Siirry vastaukseen [](indeksi)",
    "answer.viewOriginal": "Näytä alkuperäinen vastaus",
    "answer.copy.originalAnswerLink": "Kopioi linkki alkuperäiseen vastaukseen",
    "noAnswer.label": "Näyttää siltä, että kysymyksesi ei kuulu aihepiiriin, johon voimme vastata. Yritä kysyä uudelleen tai ota yhteyttä asiakaspalveluun.",
    "feedback.positive.label": "Kyllä",
    "feedback.positive.ariaLabel": "Tämä vastaus oli hyödyllinen",
    "feedback.negative.label": "Ei",
    "feedback.negative.ariaLabel": "Tämä vastaus ei ollut hyödyllinen",
    "feedback.label": "Oliko tämä vastaus hyödyllinen?",
    "feedback.label.reviewed": "Kiitos palautteestasi",
    "success.title": "Kiitos palautteestasi, olemme iloisia, että voit käyttää vastausta.",
    "success.button.title": "Takaisin vastaukseen",
    "phone.title": "Soita meille",
    "phone.subtitle": "Olet tervetullut soittamaan meille numerossa",
    "phone.openingHoursTitle": "Aukioloaikamme ovat:",
    "phone.askAnother": "Kysy uusi kysymys",
    "phone.available": "Saatavilla",
    "phone.unavailable": "Ei saatavilla",
    "email.title": "Ota yhteyttä sähköpostitse",
    "email.subtitle": "Välitämme kysymyksesi tiimin jäsenelle, joka ottaa sinuun yhteyttä mahdollisimman pian.",
    "email.userEmailPlaceholder": "Kirjoita sähköpostiosoitteesi tähän",
    "email.messagePlaceholder": "Kirjoita viestisi tähän",
    "email.error.title": "Viestin lähetys epäonnistui",
    "email.error.subtitle": "Yritä uudelleen, ja jos ongelma jatkuu, käytä toista tukikanavaamme.",
    "email.send": "Lähetä",
    "email.sending": "Lähetetään… ",
    "email.sendCopyToSelf": "Lähetä kopio minulle",
    "email.messageTemplate": "Hei asiakaspalvelu,\n \nMinulla on kysymys: [](kysymys)",
    "email.messageTemplatePostProcess": "Lähettäjä: [](käyttäjän sähköposti)\n \n[](viesti)",
    "emailSuccess.title": "Olemme vastaanottaneet sähköpostisi",
    "emailSuccess.subtitle": "Tiimimme jäsen ottaa sinuun yhteyttä antamaasi sähköpostiosoitteeseen.",
    "emailSuccess.finish": "Lopeta",
    "sidebar.close": "Sulje",
    "sidebar.originalLink": "Näytä alkuperäinen",
    "topquestions.title": "Usein kysytyt kysymykset",
    "topquestions.placeholder.heading": "Anna hakukysely",
    "topquestions.placeholder.subheading": "Annammeko sinulle välittömän vastauksen",
    "globalError.description": "Jotain meni pieleen...",
    "globalError.retryButtonLabel": "Yritä uudelleen",
    expand: "Laajentaa",
    collapse: "Romahdus",
    copied: "Kopioitu",
    copy: "Kopio",
    open: "Avata",
    references: "Viitteet",
    "show.folder": "Näytä kansio",
    "poweredBy.label": "Powered by Raffle - linkki verkkosivulle",
    "gpt.disclaimer": "The summary was generated by Raffles' large language models. As it may be flawed, please see original search results below for further detail.",
    "chat.inputPlaceholder": "Kirjoita kysymyksesi tähän",
    "chat.title": "Tervetuloa Raffle Chat!",
    "chat.description": "Voit kysyä kaikesta, mikä liittyy tähän verkkosivustoon - ja voit kysyä vapaalla tekstillä sopiviksi katsomillasi sanoilla!\n \nToivomme, että löydät kaikki tarvitsemasi vastaukset.",
    "chat.askMePrompt": "Kysy minulta mitä tahansa",
    "chat.topicTooltip": "Uusi aihe",
    "chat.regenerate": "Luo vastaus uudelleen",
    "chat.stopStream": "Lopeta vastauksen luominen",
    "chat.initialMessage": "Hei siellä! ✋ Kuinka voin auttaa sinua?",
    "chat.inappropriateQuestionResponse": "Olemme havainneet kysymyksessäsi sopimattomia elementtejä, emmekä siksi voi antaa vastausta. Ole hyvä ja muotoile uudelleen tai kysy jotain muuta.",
    "chat.noSearchResultsResponse": "Emme löytäneet kysymykseesi osuvia hakutuloksia. Yritä muotoilla kysymyksesi uudelleen tai kysy jotain muuta.",
    "chat.retryErrorMessage": "Jotain meni pieleen. Yritä hetken kuluttua uudelleen",
    "chat.searching.title": "Etsitään...",
    "chat.searching.description": "Asianmukaisten tulosten löytäminen",
    "header.title.results": "Tulokset",
    "header.title.answerPreview": "Vastauksen esikatselu",
    "header.title.chat": "Chat",
    "header.title.support": "Asiakaspalvelu",
    "header.title.phoneSupport": "Puhelintuki",
    "header.title.emailSupport": "Sähköpostituki",
    "navigation.search": "Hae",
    "cta.startConversation": "Aloita keskustelu",
    "search.noRelevantResults.title": "Emme löytäneet asiaankuuluvia vastauksia.",
    "search.noRelevantResults.description": "Löysimme sen sijaan tässä.",
    "summary.title": "Yhteenveto",
    "summary.disclaimer": "Yhteenveto vastuuvapauslauseke",
    "searchpopup.gdpr": "GDPR-vastuuvapauslauseke",
    "searchpopup.message": "Tietoja hausta",
    toolbar: "Työkalupalkin asetukset",
    "reference.open": "Avaa viite",
    "feedback.title": "Palautteesi on tärkeää!",
    "feedback.subtitle": "Vastasimmeko kysymykseesi?",
    "feedback.commentTitle": "Kiitos palautteestasi!",
    "feedback.commentSubtitle": "Arvostamme suuresti mielipidettäsi.",
    "feedback.minimizedTitle": "Hei! Olisimme erittäin kiitollisia, jos käyttäisitte muutaman sekunnin itsepalvelumme arvioimiseen.",
    "feedback.dismiss.text": "Ohita",
    "feedback.commentButton.ariaLabel": "Lähetä kommentti",
    "feedback.comment.ariaLabel": "Kommenttikenttä",
    "feedback.comment.label": "Onko sinulla kommentti?",
    "chat.activeNow": "Aktiivinen nyt",
};
const it = {
    "startButton.label": "Ricevi una risposta rapida",
    "backButton.label": "Indietro",
    "closeButton.label": "Chiudi",
    "initialPopover.title": "State cercando una risposta rapida?",
    "initialPopover.subtitle": "Clicca qui, inserisci la domanda e ricevi la risposta",
    "support.title": "Contatta il nostro servizio clienti",
    "support.subtitle": "Contatta il nostro servizio clienti attraveso una delle seguenti opzioni",
    "support.email.title": "Invia un'e-mail",
    "support.email.subtitle": "Inviaci un'e-mail e vi risponderemo il prima possibile",
    "support.iframe.title": "Invia un messaggio",
    "support.iframe.subtitle": "Inviaci un messaggio e vi risponderemo il prima possibile",
    "support.phone.title": "Telefono",
    "support.phone.subtitle": "Visualizza il nostro numero di telefono e gli orari in cui é attivo il servizio",
    "support.chat.title": "Chatta",
    "support.chat.subtitle": "Con il nostro servizio clienti",
    "support.askAnother": "Fai una nuova domanda",
    "support.error.title": "Qualcosa é andato storto...",
    "support.error.description": "Verifica la tua connessione e riprova",
    "form.title": "Fai una domanda",
    "form.titleNew": "Fai una nuova domanda",
    "form.placeholder": "Scrivi qui la tua domanda",
    "form.buttonLabel": "Cerca",
    "form.clearInput": "Cancella il testo della domanda",
    "form.validationError": "Devi digitare una domanda",
    "answer.supportLabel": "Contatta il nostro servizio clienti qui",
    "answer.showMore": "Per saperne di più",
    "answer.additionalContent.moreInfo": "Maggiori informazioni",
    "answer.error.title": "Qualcosa é andato storto...",
    "answer.error.description": "Verifica la tua connessione e riprova",
    "answers.a11y.summary": "Risposta [](index) di [](count)",
    "answers.a11y.tab": "Vai alla risposta [](index)",
    "answer.viewOriginal": "Visualizza la risposta originale",
    "answer.copy.originalAnswerLink": "Copia il link della risposta originale",
    "noAnswer.label": "Sembra che la tua domanda non rientri tra gli argomenti a cui possiamo rispondere.\n \nProva a chiedere nuovamente o contatta il nostro serivzio clienti.",
    "feedback.positive.label": "Si",
    "feedback.positive.ariaLabel": "Questa risposta é stata utile",
    "feedback.negative.label": "No",
    "feedback.negative.ariaLabel": "Questa risposta non é stata utile",
    "feedback.label": "Questa risposta é stata utile?",
    "feedback.label.reviewed": "Grazie per il tuo contributo",
    "success.title": "Grazie per il tuo contributo, siamo grati di averti aiutato.",
    "success.button.title": "Ritorna alla risposta",
    "phone.title": "Chiamaci",
    "phone.subtitle": "Puoi contattarci al numero",
    "phone.openingHoursTitle": "I nostri orari di servizio:",
    "phone.askAnother": "Fai una nuova domanda",
    "phone.available": "Disponibile",
    "phone.unavailable": "Non disponibile",
    "email.title": "Contattaci via email",
    "email.subtitle": "Trasmetteremo la vostra domanda ad uno dei nostri esperti, che vi contattera il prima possibile.",
    "email.userEmailPlaceholder": "Scrivi qui la tua email",
    "email.messagePlaceholder": "Scrivi qui il tuo messaggio",
    "email.error.title": "Non é stato possibile inviare il messaggio",
    "email.error.subtitle": "Provi di nuovo e se il problema persiste utilizzi un altro canale di supporto.",
    "email.send": "Invia",
    "email.sending": "Inviando...",
    "email.sendCopyToSelf": "Inviami una copia",
    "email.messageTemplate": "Gentile servicio clienti,\n \nHo una domanda: [](question)",
    "email.messageTemplatePostProcess": "Da: [](userEmail)\n \n[](message)",
    "emailSuccess.title": "Abbiamo ricevuto la tua email",
    "emailSuccess.subtitle": "Un membro del nostro team vi contatterà all'indirizzo email che ci avete fornito.",
    "emailSuccess.finish": "Finito",
    "sidebar.close": "Chiudi",
    "sidebar.originalLink": "Visualizza originale",
    "topquestions.title": "Domande frequenti",
    "topquestions.placeholder.heading": "Inserisci una domanda di ricerca",
    "topquestions.placeholder.subheading": "Vi daremo una risposta immediata",
    "globalError.description": "Qualcosa é andato storto.",
    "globalError.retryButtonLabel": "Prova ancora",
    expand: "Espandi",
    collapse: "Riduci",
    copied: "Copiato",
    copy: "Copia",
    open: "Apri",
    references: "Fonti",
    "show.folder": "Mostra cartella",
    "poweredBy.label": "Powered by Raffle - link al sito web",
    "gpt.disclaimer": "Questa sintesi é stata generata dai modelli linguistici di Raffle. Dato che i modelli non possono essere infallibili, si prega di consultare i risultati della ricerca originale.",
    "chat.inputPlaceholder": "Scrivi qui la tua domanda",
    "chat.title": "Benvenuto nella Chat di Raffle!",
    "chat.description": "Puoi chiedere qualsiasi cosa sia rilevante con il tuo sito utilizzando le parole che preferisci!\n \nCi auguriamo che trovi tutte le risposte di cui hai bisogno.",
    "chat.askMePrompt": "Chiedimi qualsiasi cosa...",
    "chat.topicTooltip": "Nuovo argomento",
    "chat.regenerate": "Genera nuovamente la risposta",
    "chat.stopStream": "Interrompi la generazione della risposta",
    "chat.initialMessage": "Benvenuto! ✋ Come posso aiutarti?",
    "chat.inappropriateQuestionResponse": "Abbiamo rilevato dei termini inappropriati nella tua domanda, per cui non possiamo risponderti. Per favore, prova a riscriverla.",
    "chat.noSearchResultsResponse": "Non siamo riusciti a trovare nessun risultato rilevante alla tua domanda. Prova a riscriverla o a chiedere qualcos'altro.",
    "chat.retryErrorMessage": "Qualcosa é andato storto. Per favore, attendi qualche secondo e riprova.",
    "chat.searching.title": "Sto cercando...",
    "chat.searching.description": "Cerco risultati rilevanti",
    "header.title.results": "Risultati",
    "header.title.answerPreview": "Anteprima della risposta",
    "header.title.chat": "Chat",
    "header.title.support": "Supporto",
    "header.title.phoneSupport": "Numero verde",
    "header.title.emailSupport": "Supporto via email",
    "navigation.search": "Ricerca",
    "cta.startConversation": "Inizia a chattare",
    "search.noRelevantResults.title": "Non abbiamo trovato risultati rilevanti.",
    "search.noRelevantResults.description": "Questo é quello che abbiamo trovato.",
    "summary.title": "Sintesi Smart",
    "summary.disclaimer": "Disclaimer sulla sintesi",
    "searchpopup.gdpr": "Disclaimer sulla GDPR",
    "searchpopup.message": "Informazioni della ricerca",
    toolbar: "Opzioni della barra degli strumenti",
    "reference.open": "Apri fonte",
    "feedback.title": "Il tuo contributo é importante!",
    "feedback.subtitle": "Abbiamo risposto alla tua domanda?",
    "feedback.commentTitle": "Grazie per il tuo contributo!",
    "feedback.commentSubtitle": "Apprezziamo molto la tua opinione.",
    "feedback.minimizedTitle": "Salve! Le saremmo grati se volesse dedicare qualche secondo a valutare il nostro self-service.",
    "feedback.dismiss.text": "Salta",
    "feedback.commentButton.ariaLabel": "Invia commento",
    "feedback.comment.ariaLabel": "Campo per i commenti",
    "feedback.comment.label": "Vuole lasciare un commento?",
    "chat.activeNow": "Disponibile ora",
};
module.exports = { da, en, de, fr, sv, no, nb: no, nl, pl, fi, it };
